<template>
  <popup-modal ref="popup">
    <div class="modal-scroll">
      <h5>Validering</h5>
      <div class="mt-3" :class="allValid ? 'text-success' : 'text-danger'">
        <strong>{{ allValid ? 'Alle sjekker bestått' : 'Noen sjekker feilet' }}</strong>
      </div>
      <table class="table table-sm mt-3">
        <thead>
          <tr>
            <th></th>
            <th>Sjekk</th>
            <th>Faktisk</th>
            <th>Forventet</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(r, i) in results" :key="i">
            <td :class="r.match ? 'text-success' : 'text-danger'">{{ r.match ? '✓' : '✗' }}</td>
            <td>{{ r.label }}</td>
            <td>{{ r.actual }}</td>
            <td>{{ r.expected }}</td>
          </tr>
        </tbody>
      </table>
      <div class="btn-panel">
        <button class="bo_btn" @click="close">Lukk</button>
      </div>
    </div>
  </popup-modal>
</template>

<script>
import PopupModal from '@/components/other/PopupModal.vue'

export default {
  name: 'ValidationResultModal',
  components: { PopupModal },
  data() {
    return {
      results: [],
      allValid: false
    }
  },
  methods: {
    open(results) {
      this.results = results
      this.allValid = results.every(r => r.match)
      this.$refs.popup.open()
    },
    close() {
      this.$refs.popup.close()
    }
  }
}
</script>

<style scoped>
.modal-scroll {
  max-height: 80vh;
  overflow-y: auto;
  margin-right: -1rem;
  padding-right: 1rem;
}
.btn-panel {
  display: flex;
  justify-content: flex-end;
  border-top: var(--bo-muted-2) solid 1px;
  padding-top: 15px;
}
</style>
